"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfanityOptions = void 0;
class ProfanityOptions {
    constructor() {
        this.wholeWord = true;
        this.grawlix = "@#$%&!";
        this.grawlixChar = "*";
    }
}
exports.ProfanityOptions = ProfanityOptions;
//# sourceMappingURL=profanity-options.js.map